import { NgModule } from '@angular/core';
import { HomeScreenComponent } from './home.screen.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '../../components/components.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';

@NgModule({
  declarations: [HomeScreenComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    TranslateModule,
    ComponentsModule,
    MatPaginatorModule,
    MatTableModule,
    RouterModule.forChild([
      {
        path: '',
        component: HomeScreenComponent,
      },
    ]),
  ],
})
export class HomeScreenModule {}
